<p class="title">{{ 'columns.senderID' | translate }}</p>
@for (ch of campaign.setup.channels; track $index) {
	<div class="channel">
		<alaris-icon [name]="cu.icon(ch.trafficType)"></alaris-icon>
		{{ (ch.sender | sender)?.name }}
	</div>
}
